import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { useSettings } from "@/contexts/SettingsContext";

const BranchContext = createContext(null);

export function BranchProvider({ children }) {
  const { user } = useAuth();
  const { settings } = useSettings();
  const [branches, setBranches] = useState([]);
  const [branchId, setBranchId] = useState(() => localStorage.getItem("myclinic_active_branch") || "all");

  useEffect(() => {
    if (branchId && branchId !== "all") localStorage.setItem("myclinic_active_branch", branchId);
    else localStorage.removeItem("myclinic_active_branch");
  }, [branchId]);

  useEffect(() => {
    if (!user) return;
    api.get("/branches").then((r) => setBranches(r.data)).catch(() => {});
  }, [user]);

  // If single_branch mode, force-pick the default or first branch — but NOT for
  // branch-unrestricted roles (owner/cs/crm/super_admin) who must be able to switch branches.
  useEffect(() => {
    if (!settings || branches.length === 0) return;
    const unrestricted = ["owner", "super_admin", "cs", "crm"].includes(user?.role);
    if (settings.operation_mode === "single_branch" && !unrestricted) {
      const target = settings.default_branch_id || branches[0].id;
      if (branchId !== target) setBranchId(target);
    }
  }, [settings, branches, branchId, user]);

  return (
    <BranchContext.Provider value={{ branches, branchId, setBranchId, isSingleMode: settings?.operation_mode === "single_branch" }}>
      {children}
    </BranchContext.Provider>
  );
}

export const useBranch = () => useContext(BranchContext);
